import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store/reducer';
import {
  FetchResourceAction,
  fetchResourceDelegate,
  Resource,
  ResourceActionTypes,
} from 'v2/store/common/Resource';
import { ProjectDetailState } from '../state';
import { fetchAppsForCurrentProject } from './FetchApps';
import { Product } from '../../../../data/terra/Product';
import { mapProjectToProduct } from '../../../../util/projectMapper';
import TerraBff from 'services/apis/terraBff/TerraBff';

const ActionTypes: ResourceActionTypes = {
  requestFetching: 'project/fetch',
  fetchSuccess: 'project/fetchSuccess',
  fetchFailure: 'project/fetchFailure',
};

export type FetchProjectAction = FetchResourceAction<Product>;

export const FetchCurrentProject = (): ThunkAction<
  void,
  RootState,
  unknown,
  Action<string>
> => async (dispatch, getState) => {
  const selectedProjectId = getState().projectDetail.selectedProjectId;

  if (selectedProjectId) {
    dispatch(fetchProject(selectedProjectId));
  }
};

const fetchProject = (
  projectId: string
): ThunkAction<void, RootState, unknown, Action<string>> => async dispatch => {
  dispatch({
    type: ActionTypes.requestFetching,
  } as FetchProjectAction);

  const result = await TerraBff.project.fetchProject(projectId);

  if (result.isSuccess()) {
    dispatch({
      type: ActionTypes.fetchSuccess,
      data: mapProjectToProduct(result.get()!.data),
    } as FetchProjectAction);
    dispatch(fetchAppsForCurrentProject());
  } else {
    dispatch({
      type: ActionTypes.fetchFailure,
      error: result.exception(),
    } as FetchProjectAction);
  }
};

export const fetchProjectDelegate = fetchResourceDelegate<
  ProjectDetailState,
  Product
>(
  ActionTypes,
  (
    rootState: ProjectDetailState,
    reduce: (state: Resource<Product>) => Resource<Product>
  ) => {
    return {
      ...rootState,
      project: reduce(rootState.project),
    };
  }
);
